// Image loader Module
const imageLoader = require(MODULES_PATH + '/image-loader');
new imageLoader();

// Cookie Consent Module
const cookieConsent = require(MODULES_PATH + '/cookie-consent');
new cookieConsent({
    buttonSelector: '.cookie-consent-banner__button',
    bannerSelector: '.cookie-consent-banner',
});

// Header and Footer Module
const headerFooter = require(MODULES_PATH + '/header-footer');
new headerFooter();

function getHeaderOffset() {
    const value = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();

    return parseInt(value) || 0;
}

function scrollWithOffset(id) {
    const el = document.querySelector(id);
    if (!el) return;

    const offset = getHeaderOffset();
    const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
        top: y,
        behavior: 'smooth',
    });
}

document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href*="#"]');
    if (!link) return;

    const hash = link.getAttribute('href').split('#')[1];
    if (!hash) return;

    const id = `#${hash}`;
    const el = document.querySelector(id);
    if (!el) return;

    e.preventDefault();
    scrollWithOffset(id);
});

window.addEventListener('load', function () {
    if (window.location.hash) {
        setTimeout(() => {
            scrollWithOffset(window.location.hash);
        }, 50);
    }
});
